import { useEffect, useReducer, useRef, useState } from "react";
import { Modal, Button } from "react-bootstrap";

import { formatDate, getCaseId, getClientId, getLoggedInUserId } from "../../../Utils/helper";
import { useFooter } from "../../common/shared/FooterContext";
import { api_without_cancellation } from "../../../api/api";
import avatarImage from "../../../assets/images/avatar.svg";

const CourtFormsTab = ({ data }) => {
  const tableRef = useRef(null);
  const { footerState, _setFooterState } = useFooter();
  const initialState = {
    show: false,
    status: "",
  };
  const userId = getLoggedInUserId();

  const [editExist, setEditExist] = useState(null);

  function reducer(state, action) {
    switch (action.type) {
      case "SHOW_MODAL":
        return { ...state, show: true, status: action.payload };
      case "HIDE_MODAL":
        return { ...state, show: false };

      default:
        return state;
    }
  }
  const [state, dispatch] = useReducer(reducer, initialState);
  const createEditDoc = async (docId, url, name, dynamic_template_id) => {
    try {
      const _currentUrl = window.location.href;

      const formData = new FormData();
      formData.append("doc_id", docId);
      formData.append("url", url);
      formData.append("name", name);
      formData.append("template_id", dynamic_template_id);

      const _response = await api_without_cancellation.post(
        `${origin}/api/create-edit-doc/`,
        formData
      );

      // Proceed with additional logic if needed
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const handleEditButton = (
    docId,
    templateId,
    templateName,
    edit,
    edit_by,
    edit_by_profile_pic
  ) => {
    const wp_url =
      "/bp-wordprocessor/" +
      getClientId() +
      "/" +
      getCaseId() +
      `/?docId=${docId}&dynamic_template_id=${templateId}&type=LetterTemplate`;
    const matchedItem = footerState.some((item) => item.url === wp_url);
    if (matchedItem) {
      window.location.href = wp_url;
      return;
    }

    if (edit) {
      const edit_by_user = `
     
            <p>
            The template is being edited by 
            <span className="d-flex align-items-center justify-content-center">
                <span className="ic ic-avatar ic-29 has-avatar-icon has-cover-img m-r-5">
                    ${edit_by_profile_pic ? `<img src="${edit_by_profile_pic}" className="theme-ring">` : ""}
                </span>
                <span>${edit_by?.first_name} ${edit_by?.last_name}</span>
            </span>
            It will be available when that user has closed the template.
        </p>
        
          
              
        
         
          `;
      dispatch({
        type: "SHOW_MODAL",
        payload: edit_by_user,
      });
    } else {
      if (editExist) {
        dispatch({
          type: "SHOW_MODAL",
          payload:
            "You currently have a template open for editing. Close that template before editing another.",
        });
      } else {
        createEditDoc(docId, wp_url, templateName, templateId);
        window.location.href = wp_url; // Change URL in the current tab
      }
    }
  };

  useEffect(() => {
    const hasMatchingUrl = footerState?.find((item) => item.url.includes("LetterTemplate"));
    setEditExist(hasMatchingUrl?.for_template);
  }, [footerState]);
  // const [availableRows, setAvailableRows] = useState(0);

  // useLayoutEffect(() => {
  //   if (!tableRef.current) return;

  //   const totalHeight = tableRef.current.getBoundingClientRect().height;
  //   const height = totalHeight - 25;
  //   const rowsFromHeight = Math.floor(height / 35);
  //   const rowsToSubtract = data?.length ?? 0;

  //   setAvailableRows(Math.max(0, rowsFromHeight - rowsToSubtract));
  // }, [data]);

  return (
    <>
      <div
        className="m-b-5 table--no-card rounded-0 border-0 w-100"
        style={{
          height: "305px",
          overflow: "scroll",
          scrollbarWidth: "none",
        }}
        ref={tableRef}
      >
        <table className="table table-borderless table-striped table-earning settlement-table">
          <thead>
            <tr id="settle-tb-header" className="settle-t-4 cursor-default">
              <th
                className=""
                style={{
                  width: "25px",
                  minWidth: "25px",
                  maxWidth: "25px",
                }}
              />
              <th className="text-center td-autosize">Client Name</th>
              <th className="" />
              <th className="text-center td-autosize">Draft Name</th>
              <th className="" />
              <th className="text-center td-autosize">Last Edited</th>
              <th className="" />
              <th className="text-center td-autosize">Category</th>
              <th className="" />
              <th className="text-center td-autosize">Litigation Act</th>
              <th className="" />
              <th className="text-center td-autosize">Action</th>
              <th
                className=""
                style={{
                  width: "15px",
                  minWidth: "15px",
                  maxWidth: "15px",
                }}
              />
            </tr>
          </thead>
          <tbody id="body-table mb-1">
            {data?.map((draft, idx) => {
              return (
                <>
                  <tr key={draft?.id} className="cursor-default">
                    <td className="text-center" style={{ width: "25px" }}>
                      {idx + 1}
                    </td>
                    <td className="td-autosize">
                      <div
                        className="d-flex align-items-center height-21"
                        style={{
                          gap: "5px",
                          color: "black",
                          fontWeight: "bold",
                        }}
                      >
                        <span className="ic-avatar ic-15 has-avatar-icon has-cover-img">
                          <img
                            className="output-18 theme-ring"
                            src={
                              draft?.for_client_profile?.avatar
                                ? draft?.for_client_profile?.avatar
                                : avatarImage
                            }
                            style={{
                              background: "var(--primary-30)",
                            }}
                          />
                        </span>
                        <p className="">
                          {draft?.for_client_profile?.first_name}{" "}
                          {draft?.for_client_profile?.last_name}
                        </p>
                      </div>
                    </td>
                    <td />
                    <td className="td-autosize">{draft?.document_name}</td>
                    <td />
                    <td className="td-autosize">{formatDate(draft?.created_at)}</td>
                    <td />
                    <td className="td-autosize">
                      <div className="d-flex align-items-center justify-content-center">
                        <span className="ic ic-15 d-flex align-items-center justify-content-center">
                          <img src={draft?.for_template?.for_page?.page_icon} />
                        </span>
                        <span className="p-l-5">{draft?.for_template?.for_page?.name}</span>
                      </div>
                    </td>
                    <td />
                    <td />
                    <td />
                    <td>
                      <div className="d-flex justify-content-center space-x-5">
                        <Button
                          variant={
                            draft.edit_by
                              ? draft.edit_by.id === userId
                                ? "primary"
                                : "secondary"
                              : editExist
                                ? editExist === draft.id
                                  ? "primary"
                                  : "secondary"
                                : "primary"
                          }
                          className="height-20 d-flex align-items-center justify-content-center"
                          onClick={() =>
                            handleEditButton(
                              draft?.for_template?.for_template?.id,
                              draft?.id,
                              draft?.for_template.for_template?.template_name,
                              draft?.edit,
                              draft?.edit_by,
                              draft?.edit_by_profile_pic
                            )
                          }
                        >
                          <span>Edit</span>
                          <span>
                            <i className="ic ic-15 edit-template-icon ms-1" />
                          </span>
                        </Button>
                      </div>
                    </td>
                    <td />
                  </tr>
                </>
              );
            })}
            {[...Array(Math.max(8 - (data?.length || 0), 0))].map((_, index) => (
              <tr key={`fake-row-${index}`} className="fake-row-2" style={{ height: "35px" }}>
                <td colSpan="16">&nbsp;</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {
        <Modal show={state.show} onHide={() => dispatch({ type: "HIDE_MODAL" })}>
          <Modal.Header>
            <Modal.Title
              dangerouslySetInnerHTML={{ __html: state.status }}
              className="modal-title h4 justify-content-center text-center"
            />
          </Modal.Header>
          <Modal.Footer style={{ borderTop: "none" }}>
            <Button
              variant="secondary"
              className="mx-auto"
              onClick={() => dispatch({ type: "HIDE_MODAL" })}
            >
              Dismiss
            </Button>
          </Modal.Footer>
        </Modal>
      }
    </>
  );
};

export default CourtFormsTab;
